
import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Table, Form, Button, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaChevronDown,
  FaEye,
  FaDownload,
  FaReceipt,
  FaUpload,
  FaEdit,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import Papa from "papaparse";
import pdfimage from "../images/pdf_downlaod.png";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import { BASE_URL } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";

const QueryCasePage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useContext(AuthContext);
  const { invoice, vendorId, isExcelUpload } = state || {};
  console.log("hello this is data ", invoice);
  const fileInputRef = useRef();
  const modalFileInputRef = useRef();
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    uploadedFile: false,
    remarks: {},
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editValues, setEditValues] = useState({
    serviceCharges: "",
    repairCharges: "",
    remarks: "",
    file: null,
    fileName: "",
  });

  const itemsPerPage = 10;
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirstItem, indexOfLastItem);
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);

  const totalRepairCharges = currentInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = currentInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const grossAmount = totalServiceCharges + totalRepairCharges;
  // Calculate total GST only on the service charges (18%)
  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2) // GST = 18% of service charges
    : (0).toFixed(2); // No GST if not applied
  const totalservicechargewithGST = (totalServiceCharges + parseFloat(gstAmount)).toFixed(2);

  // Calculate final amount: repair charges + service charges + GST on service only
  const finalAmount = (
    totalRepairCharges + // without GST
    totalServiceCharges + // without GST
    parseFloat(gstAmount) // GST only on service
  ).toFixed(2);


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const formatDate = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") return "--";

    if (!isNaN(dateTimeStr)) {
      const serial = parseFloat(dateTimeStr);
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      return date_info.toLocaleDateString("en-GB"); // DD/MM/YYYY
    }

    const [datePart] = dateTimeStr.split(" ");
    if (!datePart.includes("-")) return "--";

    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return "--";

    return `${day}/${month}/${year}`;
  };
  const formatINVOICEDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";

    const normalized = dateStr.replaceAll("/", "-").trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      return normalized;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(normalized)) {
      const [day, month, year] = normalized.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    const monthMap = {
      Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
      Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
    };

    const match = dateStr.match(/^([A-Za-z]+)\s+(\d{1,2})\s+(\d{4})/);
    if (match) {
      const [, mon, day, year] = match;
      const month = monthMap[mon];
      if (month) {
        return `${year}-${month}-${day.padStart(2, "0")}`;
      }
    }

    return "";
  };
  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);

  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);

  useEffect(() => {
    console.log("Selected Batch Data:", invoice);
    if (!invoice) {
      navigate("/invoice");
      return;
    }
    setInvoiceNo(invoice.invoiceNumber || "");
    setInvoiceDate(formatINVOICEDate(invoice.invoiceDate) || "");
    setInvoiceAmount(
      invoice.invoiceAmount
        ? invoice.invoiceAmount.toString()
        : ""
    );
    setCaseCount(
      invoice.caseCount ? invoice.caseCount.toString() : ""
    );

    setIsLoading(true);
    if (invoice.aaNo) {
      const aaNumbers = invoice.aaNo
        .split(",")
        .map((val) => val.trim());

      Promise.all(
        aaNumbers.map((aaNo) =>
          fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNo}`)
            .then((response) => {
              if (!response.ok) {
                console.error(
                  `HTTP error for aaNo ${aaNo}: ${response.status}`
                );
                return null;
              }
              return response.json();
            })
            .then((responseData) => {
              if (!responseData || !responseData.dataItems) {
                return [];
              }
              return Array.isArray(responseData.dataItems)
                ? responseData.dataItems
                : [];
            })
            .catch((error) => {
              console.error(`Error fetching API data for ${aaNo}:`, error);
              return [];
            })
        )
      )
        .then((results) => {
          const combinedData = results.flat().filter((item) => item);
          setApiData(combinedData);
        })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
          setApiData([]);
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [invoice, navigate]);

  useEffect(() => {
    if (!invoice) return;
    const splitData = (key) =>
      invoice[key]?.split(",").map((val) => val.trim()) || [];
    const invoicesArray = splitData("aaNo").map((_, i) => {
      const remarkFileUrl = splitData("remarkFile")[i];
      return {
        aA_Number: splitData("aaNo")[i],
        imeiNumber: splitData("imeiNo")[i],
        creationDate: invoice.creationDate || "",
        closureDate: invoice.closureDate || "",
        customerName: splitData("customerName")[i],
        serviceType: splitData("serviceType")[i],
        brand: splitData("brand")[i],
        makeModel: splitData("makeModel")[i],
        repairCharges: splitData("repairCharges")[i]
          ? parseFloat(splitData("repairCharges")[i]).toFixed(2)
          : "0.00",
        serviceCharges: splitData("serviceCharges")[i]
          ? parseFloat(splitData("serviceCharges")[i]).toFixed(2)
          : "0.00",
        total: splitData("total")[i]
          ? parseFloat(splitData("total")[i]).toFixed(2)
          : "0.00",
        invoiceStatus: invoice.invoiceStatus || "-",
        networkAndFinanceStatus: splitData("networkAndFinanceStatus")[i],
        uniqueAAQuery: invoice.uniqueAAQuery,
        sellingPartner: splitData("sellingPartner")[i],
        batchNo: invoice.batchNo || "",
        isChecked: true,
        remarks: splitData("remarks")[i] || "",
        remarkFile: remarkFileUrl
          ? { name: remarkFileUrl.split("/").pop(), url: remarkFileUrl }
          : null,
      };
    });
    setInvoices(invoicesArray);
  }, [invoice]);
  const isRowDisabled = (invoice) => {
    const allowedAA = getAllowedAANumbers();

    if (allowedAA.length === 0) return true;

    return !allowedAA.includes(invoice.aA_Number);
  };
  const getAllowedAANumbers = () => {
    const aaNumbers = currentInvoices
      .map(invoice => invoice.uniqueAAQuery)
      .filter(Boolean);
    if (aaNumbers.length === 0) return [];

    return aaNumbers.flatMap(aaString =>
      aaString.split(",").map(aa => aa.trim())
    );
  };
  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();

  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData)) return "row-red";
      const matchedData = apiData.find(
        (item) => item && item.aA_Number === invoice.aA_Number
      );
      if (!matchedData) return "row-red";
      if (
        normalize(matchedData.serviceType) !== normalize(invoice.serviceType) ||
        normalize(matchedData.sellingPartner) !==
        normalize(invoice.sellingPartner) ||
        normalize(matchedData.repairCharges) !==
        normalize(invoice.repairCharges) ||
        normalize(matchedData.serviceCharges) !==
        normalize(invoice.serviceCharges) ||
        normalize(matchedData.total) !== normalize(invoice.total)
      ) {
        return "row-yellow";
      }
      return "row-green";
    },
    [apiData]
  );

  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item && item.aA_Number === invoice.aA_Number
    );
    if (!matchedData)
      return [{ field: "AA Number", table: invoice.aA_Number, api: "-" }];
    const differences = [];
    if (normalize(matchedData.serviceType) !== normalize(invoice.serviceType)) {
      differences.push({
        field: "Service Type",
        table: invoice.serviceType || "",
        api: matchedData.serviceType || "",
      });
    }
    if (normalize(matchedData.imeiNumber) !== normalize(invoice.imeiNumber)) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "",
        api: matchedData.imeiNumber || "",
      });
    }
    if (
      normalize(matchedData.sellingPartner) !==
      normalize(invoice.sellingPartner)
    ) {
      differences.push({
        field: "Selling Partner",
        table: invoice.sellingPartner || "",
        api: matchedData.sellingPartner || "",
      });
    }
    if (
      normalize(matchedData.repairCharges) !== normalize(invoice.repairCharges)
    ) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "",
        api: matchedData.repairCharges || "",
      });
    }
    if (
      normalize(matchedData.serviceCharges) !==
      normalize(invoice.serviceCharges)
    ) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "",
        api: matchedData.serviceCharges || "",
      });
    }
    if (normalize(matchedData.total) !== normalize(invoice.total)) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "",
        api: matchedData.total || "",
      });
    }
    return differences.length > 0 ? differences : [];
  };

  const handleDelete = (index) => {
    const updatedInvoices = invoices.filter((_, i) => i !== index);
    setInvoices(updatedInvoices);
    if (updatedInvoices.length === 0) {
      navigate("/");
    }
  };

  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      )
    );
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const extension = file.name.split(".").pop().toLowerCase();
    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));
    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const row = results.data[0];
          setInvoiceNo(row["Invoice No"] || invoice.invoiceNumber || "");
          setInvoiceDate(
            formatDate(row["Invoice Date"]) || invoice.invoiceDate || ""
          );
          setInvoiceAmount(
            row["Invoice Amount"]
              ? row["Invoice Amount"].toString()
              : invoice.invoiceAmount
                ? invoice.invoiceAmount.toString()
                : ""
          );
          setCaseCount(
            row["Case Count"]
              ? row["Case Count"].toString()
              : invoice.caseCount
                ? invoice.caseCount.toString()
                : ""
          );
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to read CSV file.");
        },
      });
    }
  };

  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      "CustomerName",
      "ServiceType",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      "InvoiceStatus",
      // "Remarks",
      // "RemarkFile",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber ? `="${invoice.imeiNumber}"` : "",
      customerName: invoice.customerName || "",
      serviceType: invoice.serviceType || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
      invoiceStatus: invoice.invoiceStatus || "",
      // remarks: invoice.remarks || "",
      // remarkFile: invoice.remarkFile
      //   ? invoice.remarkFile.name || invoice.remarkFile
      //   : "",

    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const selectedInvoices = invoices.filter((invoice) => invoice.isChecked && !isRowDisabled(invoice));

  const leftSideTotalRepairCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideTotalServiceCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideGstAmount = isGSTApplied
    ? (leftSideTotalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const leftSideGrossAmount = leftSideTotalRepairCharges + leftSideTotalServiceCharges;
  const leftSideFinalAmount = isGSTApplied
    ? (leftSideGrossAmount + parseFloat(leftSideGstAmount)).toFixed(2)
    : leftSideGrossAmount.toFixed(2);

  const leftSideTotalservicechargewithGST = (leftSideTotalServiceCharges + parseFloat(leftSideGstAmount)).toFixed(2);
  const leftSideCaseCount = selectedInvoices.length;

  const handleSubmit = async () => {
    try {
      const selected = invoices.filter((inv) => inv.isChecked);
      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      const invoiceAmountStr = invoiceAmount ? invoiceAmount.toString() : "";
      const caseCountStr = caseCount ? caseCount.toString() : "";

      const newErrors = {
        invoiceNo: !invoiceNo.trim(),
        invoiceDate: !invoiceDate,
        invoiceAmount:
          !invoiceAmountStr.trim() ||
          isNaN(parseFloat(invoiceAmountStr)) ||
          parseFloat(invoiceAmountStr) <= 0,
        caseCount:
          !caseCountStr.trim() ||
          isNaN(parseInt(caseCountStr)) ||
          parseInt(caseCountStr) <= 0,
        uploadedFile: false,
        remarks: {},
      };

      let hasRemarkError = false;
      selected.forEach((invoice) => {
        const isYellowRow = getRowClassName(invoice) === "row-yellow";
        const isRemarkEmpty = !invoice.remarks?.trim();
        if (isYellowRow && isRemarkEmpty) {
          newErrors.remarks[invoice.aA_Number] = true;
          hasRemarkError = true;
        } else {
          newErrors.remarks[invoice.aA_Number] = false;
        }
      });

      setFieldErrors(newErrors);

      // if (newErrors.uploadedFile || ) {
      //   toast.error("Please upload an invoice file.");
      // }
      if (newErrors.invoiceNo) {
        toast.error("Invoice No is required.");
      }
      if (newErrors.invoiceDate) {
        toast.error("Invoice Date is required.");
      }
      if (newErrors.invoiceAmount) {
        toast.error("Invoice Amount must be a valid positive number.");
      }
      if (newErrors.caseCount) {
        toast.error("Case Count must be a valid positive number.");
      }
      if (hasRemarkError) {
        toast.error(
          "Remarks are required for all yellow rows (mismatched data)."
        );
      }

      if (
        Object.values(newErrors).some((error) => error === true) ||
        hasRemarkError
      ) {
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      if (invoiceDate > today) {
        setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
        toast.error("Invoice Date cannot be a future date.");
        return;
      }

      const parsedCaseCount = parseInt(caseCountStr);
      if (parsedCaseCount !== selected.length) {
        setFieldErrors((prev) => ({ ...prev, caseCount: true }));
        toast.error(
          "Case Count does not match the number of selected services."
        );
        return;
      }

      // const parsedInvoiceAmount = parseFloat(invoiceAmountStr);
      // if (Math.abs(parsedInvoiceAmount - parseFloat(finalAmount)) > 0.01) {
      //   setFieldErrors((prev) => ({ ...prev, invoiceAmount: true }));
      //   // setAmountError("Invoice Amount and Final Amount do not match.");
      //   return;
      // } else {
      //   setAmountError("");
      // }

      let hasMismatch = false;
      for (const invoice of selected) {
        const matchedData = apiData.find(
          (item) => item.aA_Number === invoice.aA_Number
        );
        if (!matchedData) {
          toast.error(
            `AA Number ${invoice.aA_Number} not found in reference data. Please delete the row or check the source.`
          );
          return;
        }

        if (
          normalize(matchedData.serviceType) !==
          normalize(invoice.serviceType) ||
          normalize(matchedData.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(matchedData.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(matchedData.total) !== normalize(invoice.total)
        ) {
          hasMismatch = true;
        }
      }

      if (hasMismatch) {
        const confirmProceed = window.confirm(
          "Warning: Some invoice fields do not match the original data.\nDo you want to proceed anyway?"
        );
        if (!confirmProceed) return;
      }

      const formData = new FormData();
      const extract = (key) =>
        selected.map((item) => item[key] || "").join(", ");
      formData.append("AANo", extract("aA_Number"));
      formData.append("IMEINo", extract("imeiNumber"));
      formData.append("CreationDate", extract("creationDate"));
      formData.append("ClosureDate", extract("closureDate"));
      formData.append("CustomerName", extract("customerName"));
      formData.append("Remarks", extract("remarks"));
      formData.append("VendorName", invoice?.vendorName || "");
      formData.append("finalAmount", finalAmount);
      formData.append("TotalRepairCharges", totalRepairCharges.toFixed(2));
      formData.append("TotalServiceCharges", totalServiceCharges.toFixed(2));
      formData.append("BatchNo", invoice?.batchNo || "");
      formData.append("ServiceType", extract("serviceType"));
      formData.append("Brand", extract("brand"));
      formData.append("MakeModel", extract("makeModel"));
      formData.append("RepairCharges", extract("repairCharges"));
      formData.append("ServiceCharges", extract("serviceCharges"));
      formData.append("Total", extract("total"));
      formData.append("SellingPartner", extract("sellingPartner"));
      formData.append(
        "InvoiceStatus",
        uploadedFile || invoice?.pdf ? "Invoice Uploaded" : "No Invoice Uploaded"
      );

      formData.append("InvoiceNo", invoiceNo);
      formData.append("InvoiceDate", invoiceDate);
      formData.append("InvoiceAmount", invoiceAmountStr);
      formData.append("CaseCount", caseCountStr);
      formData.append("IsGSTApplied", isGSTApplied ? "true" : "false");
      // if (invoice?.pdf) {
      //   const response = await fetch(invoice.pdf);
      //   const blob = await response.blob();
      //   const url = new URL(invoice.pdf);
      //   const filename = url.searchParams.get("fileName");
      //   formData.append("Invoice", blob, filename);
      // } else if (uploadedFile) {
      //   formData.append("Invoice", uploadedFile, uploadedFile.name);
      // }
      const fileUrl = invoice?.pdf || "";
      const fileName = fileUrl ? fileUrl.split("fileName=")[1] : "";
      if (invoice?.pdf) {
        formData.append("invoice", fileName);

      } else if (uploadedFile) {
        formData.append("Invoice", uploadedFile, uploadedFile.name);
      }


      // Handle RemarkFile logic
      const invoiceWithFile = selected.find((inv) => inv.remarkFile);

      if (invoiceWithFile) {
        const remark = invoiceWithFile.remarkFile;

        if (remark instanceof File) {
          // If a new file was uploaded via the modal
          formData.append("RemarkFile", remark, remark.name);
        } else if (remark?.url && typeof remark.url === "string") {
          // If the file is coming as URL from previous page
          const fileName = remark.name || "remark-file.pdf";
          try {
            const response = await fetch(remark.url);
            if (response.ok) {
              const blob = await response.blob();
              formData.append("RemarkFile", blob, fileName);
            } else {
              // Append null silently if fetch fails
              formData.append("RemarkFile", null);
            }
          } catch (err) {
            // Do not toast error, just append null
            formData.append("RemarkFile", null);
          }
        } else {
          // No valid file or URL
          formData.append("RemarkFile", null);
        }
      } else {
        // No invoiceWithFile case
        formData.append("RemarkFile", null);
      }

      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/SaveOrUpdateApprovalBatchData`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      setIsLoading(false);

      if (!response.ok) {
        toast.error("Error submitting batch. Check the payload or try again.");
        return;
      }
      const aanoString = selected.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch send to pending Approval");
      remarkFormData.append("BatchNo", invoice?.batchNo);
      remarkFormData.append("ByWhom", user?.role);
      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }

      toast.success("Batch submitted successfully.");
      navigate("/approval");
      localStorage.removeItem("invoices")
    } catch (error) {
      console.error("Submission failed:", error);
      setIsLoading(false);
      toast.error("Submission failed. Please check console for details.");
    }
  };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setEditValues({
      serviceCharges: invoice.serviceCharges || "0.00",
      repairCharges: invoice.repairCharges || "0.00",
      remarks: invoice.remarks || "",
      file: invoice.remarkFile instanceof File ? invoice.remarkFile : null,
      fileName:
        invoice.remarkFile && typeof invoice.remarkFile === "object"
          ? invoice.remarkFile.name
          : invoice.remarkFile || "",
    });
    setShowEditModal(true);
  };

  const handleSaveEdit = async () => {
    if (!editingInvoice) return;

    const parsedServiceCharges = parseFloat(editValues.serviceCharges);
    const parsedRepairCharges = parseFloat(editValues.repairCharges);
    const remarks = editValues.remarks?.trim() || "";

    if (
      isNaN(parsedServiceCharges) ||
      parsedServiceCharges < 0 ||
      isNaN(parsedRepairCharges) ||
      parsedRepairCharges < 0
    ) {
      toast.error(
        "Service Charges and Repair Charges must be valid non-negative numbers."
      );
      return;
    }

    const isYellowRow = getRowClassName(editingInvoice) === "row-yellow";
    if (isYellowRow && !remarks) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: true },
      }));
      toast.error("Remarks are required for mismatched data.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("aano", editingInvoice?.aA_Number);
      formData.append("remark", editValues.remarks);
      formData.append("remarkFile", editValues.file);
      formData.append("RemarkBy", user.role);
      formData.append("BillingType", editingInvoice?.billingType || "billing");
      formData.append("Document", null);

      const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status) {
        alert("Remark updated successfully");
        toast.success("Remark updated successfully.");
        handleCloseModal();
      } else {
        alert("Failed to update: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Network error: " + error.message);
    }

    const formattedServiceCharges = parsedServiceCharges.toFixed(2);
    const formattedRepairCharges = parsedRepairCharges.toFixed(2);
    const formattedTotal = (parsedServiceCharges + parsedRepairCharges).toFixed(
      2
    );

    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice) =>
        invoice.aA_Number === editingInvoice.aA_Number
          ? {
            ...invoice,
            serviceCharges: formattedServiceCharges,
            repairCharges: formattedRepairCharges,
            total: formattedTotal,
            remarks: remarks,
            remarkFile: editValues.file
              ? editValues.file
              : editValues.fileName
                ? { name: editValues.fileName, url: editValues.fileName }
                : null,
          }
          : invoice
      )
    );
    setFieldErrors((prev) => ({
      ...prev,
      remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
    }));
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      remarks: "",
      file: null,
      fileName: "",
    });
  };
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
    if (name === "remarks" && editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: !value.trim() },
      }));
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      remarks: "",
      file: null,
      fileName: "",
    });
    if (editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
    }
  };

  const handleRemarkChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({
        ...prev,
        file,
        fileName: file.name,
      }));
    }
  };
  const getFileNameFromUrl = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return decodeURIComponent(params.get("fileName"));
  };

  const handleLOGSremarks = (aa_number) => {
    navigate(`/Remarks&Logs/${aa_number}`)
  }
  return (
    <div
      className="container py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card shadow-sm p-4">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            backgroundColor: "#e6f0ff",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2 className="mb-0">Upload Invoice</h2>
          <button
            className="btn btn-primary d-flex align-items-center"
            style={{
              backgroundColor: "#8000d7",
              border: "none",
              padding: "10px 16px",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "14px",
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>

        <div className="netwrok_table_main_content">
          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
            <div className="d-flex flex-wrap gap-2 align-items-center">
              {invoice?.batchNo && (
                <div className="fw-semibold">
                  <span>Batch No: </span>
                  <span className="text-primary">
                    {invoice.batchNo}
                  </span>
                </div>
              )}
              {invoice?.vendorName && (
                <div className="fw-semibold">
                  <span>Vendor: </span>
                  <span className="text-success">
                    {invoice.vendorName}
                  </span>
                </div>
              )}
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
                onClick={handleClick}
              >
                <FaUpload /> <span className="ms-2">Upload Invoice</span>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => {
                  handleFileChange(e);
                  setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));
                }}
                style={{ display: "none" }}
                accept="*"
              />
            </div>
          </div>

          {invoice?.pdf ? (
            <div className="text-end upload_file_ext_name mb-3">
              <span className="fw-bold text-success" style={{ cursor: "pointer" }} onClick={() => window.open(invoice.pdf, "_blank")}>
                {getFileNameFromUrl(invoice?.pdf)}
              </span>
              {invoice.pdf.endsWith(".pdf") ? (
                <img
                  src={pdfimage}
                  alt="PDF Icon"
                  style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            fileType &&
            uploadedFile && (
              <div className="text-end upload_file_ext_name mb-3">
                <span className="fw-bold text-success" style={{ cursor: "pointer" }} onClick={() => window.open(URL.createObjectURL(uploadedFile), "_blank")}>
                  {uploadedFile.name}
                </span>

                {fileType === "pdf" ? (
                  <img
                    src={pdfimage}
                    alt="PDF Icon"
                    style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                  />
                ) : fileType === "image" ? (
                  <img
                    src={URL.createObjectURL(uploadedFile)}
                    alt="Image Preview"
                    style={{ width: "50px", height: "50px", marginLeft: "10px", objectFit: "cover", borderRadius: "4px" }}
                  />
                ) : null}
              </div>
            )
          )}
          {!uploadedFile && !invoice?.pdf && fieldErrors.uploadedFile && (
            <div className="text-danger mb-3" style={{ fontSize: "14px" }}>
              Please upload an invoice file.
            </div>
          )}
          <div
            className="table-container mt-3"
            style={{ overflowX: "auto", overflowY: "auto" }}
          >
            <Table className="table-auto bg-white text-center border-dark network_table">
              <thead
                style={{
                  backgroundColor: "#EEF4FF",
                  position: "sticky",
                  top: "0",
                  zIndex: "1",
                }}
              >
                <tr className="text-dark fw-semibold table_th_border">
                  <th className="border-start d-flex gap-2">
                    <Form.Check
                      type="checkbox"
                      checked={
                        invoices.length > 0 &&
                        invoices.every((invoice) => invoice.isChecked)
                      }
                      onChange={() => handleCheckboxChange("all")}
                      disabled={invoices.some((inv) => isRowDisabled(inv))}
                    />
                    Select
                  </th>
                  <th className="border-start">View</th>
                  <th className="border-start">Edit</th>
                  <th className="border-start">Remarks</th>
                  <th style={{ whiteSpace: "nowrap" }}>AA No</th>
                  <th style={{ whiteSpace: "nowrap" }}>IMEI No</th>
                  <th style={{ whiteSpace: "nowrap" }}>Creation Date</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Closure Date</th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                  <th style={{ whiteSpace: "nowrap" }}>Service Type</th>
                  <th style={{ whiteSpace: "nowrap" }}>Selling Partner</th>
                  <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                  <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                  <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                  <th style={{ whiteSpace: "nowrap" }}>Service (Pre GST)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Total</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Mismatched Data
                  </th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remarks
                  </th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remark File
                  </th>
                  {/* <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Action
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan="20" className="text-center py-3">
                      Validating data...
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  currentInvoices.map((invoice, index) => {
                    const disabled = isRowDisabled(invoice);
                    return (
                      <tr
                        key={invoice.id || `${invoice.aA_Number}-${index}`}
                        className={`text-center border-bottom network_td_item ${getRowClassName(invoice)} ${isRowDisabled(invoice) ? 'table-row-disabled' : ''}`}
                        style={{
                          opacity: isRowDisabled(invoice) ? 0.6 : 1,
                          backgroundColor: isRowDisabled(invoice) ? '#f2f2f2' : 'transparent',
                          pointerEvents: isRowDisabled(invoice) ? 'none' : 'auto'
                        }}
                      >
                        <td className="border-start align-middle">
                          <Form.Check
                            type="checkbox"
                            checked={invoice.isChecked}
                            onChange={() =>
                              handleCheckboxChange(invoice.aA_Number)
                            }
                            disabled={disabled}
                          />
                        </td>
                        <td className="border-start align-middle">
                          <FaEye
                            size={25}
                            className="text-purple-600 review_fa_eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleViewClick(invoice.aA_Number)}
                          />
                        </td>
                        <td className="border-start align-middle">
                          <FaEdit
                            size={20}
                            className="text-purple-600 review_fa_eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEdit(invoice)}
                          />
                        </td>
                        <td className="border-start align-middle">
                          <FaReceipt
                            size={20}
                            className="text-purple-600 review_fa_eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLOGSremarks(invoice.aA_Number)}
                          />
                        </td>
                        <td className="align-middle">
                          {invoice.aA_Number || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.imeiNumber || "-"}
                        </td>
                        <td className="align-middle">
                          {new Date().toLocaleDateString("en-GB")}
                        </td>
                        {/* <td className="align-middle">
                        {invoice.closureDate || "-"}
                      </td> */}
                        <td className="align-middle">
                          {invoice.customerName || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.serviceType || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.sellingPartner || "-"}
                        </td>
                        <td className="align-middle">{invoice.brand || "-"}</td>
                        <td className="align-middle">
                          {invoice.makeModel || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.repairCharges || "0.00"}
                        </td>
                        <td className="align-middle">
                          {invoice.serviceCharges || "0.00"}
                        </td>
                        <td className="align-middle">
                          {invoice.total || "0.00"}
                        </td>
                        <td className="align-middle">
                          <span
                            className="vendore_invoice_status px-2 py-1 rounded-pill"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {invoice.networkAndFinanceStatus || ""}
                          </span>
                        </td>
                        <td className="align-middle">
                          {getDifferencesData(invoice).length > 0
                            ? "Mismatch"
                            : "Valid"}
                          <div
                            className="align-middle position-relative"
                            onMouseEnter={() => setHoveredRow(index)}
                            onMouseLeave={() => setHoveredRow(null)}
                            style={{ cursor: "pointer", position: "relative" }}
                          >
                            {getDifferencesData(invoice).length > 0
                              ? "View Details"
                              : ""}
                            {hoveredRow === index &&
                              getDifferencesData(invoice).length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "-18%",
                                    transform: "translateX(-50%)",
                                    zIndex: "1000",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #ddd",
                                    padding: "10px",
                                    boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <table className="table table-sm table-bordered table-hover mb-0">
                                    <thead>
                                      <tr>
                                        <th className="text-left">Field</th>
                                        <th className="text-left">Excel Data</th>
                                        <th className="text-left">System Data</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {getDifferencesData(invoice).map(
                                        (diff, i) => (
                                          <tr key={i}>
                                            <td className="text-left">
                                              {diff.field}
                                            </td>
                                            <td className="text-left">
                                              {diff.table}
                                            </td>
                                            <td className="text-left">
                                              {diff.api}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                          </div>
                        </td>
                        <td className="align-middle border-end">
                          <span>
                            {invoice.remarks || "-"}
                            {getRowClassName(invoice) === "row-yellow" &&
                              !invoice.remarks && (
                                <span className="text-danger ms-1">*</span>
                              )}
                          </span>
                        </td>
                        <td className="align-middle border-end">
                          {invoice.remarkFile ? (
                            <a
                              href={invoice.remarkFile.url || invoice.remarkFile}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        {/* <td
                        className="align-middle border-end pointer-cursor"
                        style={{ cursor: "pointer" }}
                      >
                        <FaTrash
                          onClick={() => handleDelete(index)}
                          size={25}
                          style={{ color: "red" }}
                        />
                      </td> */}
                      </tr>
                    )
                  })}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

          <div className="row justify-content-between align-items-start mt-2">
            {/* Left Column */}
            <div className="col-6">
              {/* GST Toggle */}
              <div className="border rounded p-2 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="fw-bold ms-2">
                    <span>GST</span>
                  </div>
                  <div className="d-flex gap-3">
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === true}
                        onChange={() => setIsGSTApplied(true)}
                      />
                      <span className="registration_applied_yes">Yes</span>
                    </label>
                    <span className="mx-1">/</span>
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === false}
                        onChange={() => setIsGSTApplied(false)}
                      />
                      <span className="registration_applied_yes">No</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Selected Services */}
              <div
                style={{
                  backgroundColor: "#eef4ff",
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontWeight: 600, color: "gray" }}>
                  Total no of selected invoices:
                </span>
                <span style={{ fontWeight: "bold", color: "black" }}>
                  {leftSideCaseCount}
                </span>
              </div>

              {/* Amount Summary */}
              <div
                className="batch_popup_gross_ammount mt-2 w-100"
                style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}
              >
                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Repair Charges</div>
                  <div className="text-end batch_amount_to_fix">
                    ₹ {parseFloat(leftSideTotalRepairCharges).toFixed(2)}
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Logistics and Repair Support Fees</div>
                  <div className="d-flex align-items-center">
                    <div className="batch_amount_to_fix">
                      ₹ {leftSideTotalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Final Amount</div>
                  <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}>
                    <b>₹ {leftSideFinalAmount}</b>
                  </div>
                </div>

                <div className="mt-2 d-flex justify-content-end">
                  <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                    {isGSTApplied
                      ? `GST Amount Added: ₹${leftSideGstAmount}`
                      : `No GST Applied (₹${leftSideGstAmount})`}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column (Form) */}
            <div className="col-6" style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}>
              <form className="mt-4 invoice_form">
                <div className="row align-items-center">
                  {/* Case Count */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Case Count</label>
                    <input
                      type="number"
                      className={`form-control border-dark ${fieldErrors.caseCount ? "is-invalid" : ""}`}
                      placeholder="Enter Case Count"
                      value={caseCount}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCaseCount(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          caseCount: !value.trim() || isNaN(value) || parseInt(value) <= 0,
                        }));
                      }}
                      min="0"
                      disabled
                    />
                  </div>
                  {fieldErrors.caseCount && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Case Count must be a valid positive number.
                    </div>
                  )}

                  {/* Invoice No */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice No</label>
                    <input
                      type="text"
                      className={`form-control border-dark ${fieldErrors.invoiceNo ? "is-invalid" : ""}`}
                      placeholder="Enter Invoice No"
                      value={invoiceNo}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceNo(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceNo: !value.trim(),
                        }));
                      }}
                      disabled
                    />
                  </div>
                  {fieldErrors.invoiceNo && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Invoice No is required.
                    </div>
                  )}

                  {/* Invoice Date */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice Date</label>
                    <input
                      type="date"
                      className={`form-control border-dark ${fieldErrors.invoiceDate ? "is-invalid" : ""}`}
                      value={invoiceDate}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceDate(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceDate:
                            !value.trim() ||
                            value > new Date().toISOString().split("T")[0],
                        }));
                      }}
                      disabled
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>
                  {fieldErrors.invoiceDate && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Invoice Date is required and cannot be a future date.
                    </div>
                  )}

                  {/* Invoice Amount */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice Amount</label>
                    <input
                      type="number"
                      className={`form-control border-dark ${fieldErrors.invoiceAmount || amountError ? "is-invalid" : ""}`}
                      placeholder="Enter Invoice Amount"
                      value={invoiceAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceAmount(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceAmount:
                            !value.trim() ||
                            isNaN(value) ||
                            parseFloat(value) <= 0,
                        }));
                        if (value && !isNaN(parseFloat(value))) {
                        } else {
                          setAmountError("");
                        }
                      }}
                      min="0"
                      step="0.01"
                    />
                  </div>
                  {amountError && (
                    <div className="text-danger mt-2" style={{ fontSize: "14px" }}>
                      {amountError}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>


          <div className="d-flex mt-3 justify-content-center gap-3">
            <button
              onClick={downloadCSV}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "rgb(248, 238, 255)",
                border: "1px solid #8000d7",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "14px",
                color: "#8000d7",
              }}
            >
              <FaDownload />
              <span className="ms-2">Download</span>
            </button>
            <button
              onClick={handleSubmit}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Submit"}
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoices (AA No: {editingInvoice?.aA_Number})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Repair Charges</Form.Label>
              <Form.Control
                type="number"
                name="repairCharges"
                value={editValues.repairCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                placeholder="Enter Repair Charges"
                size="lg"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Logistics and Repair Support Fees</Form.Label>
              <Form.Control
                type="number"
                name="serviceCharges"
                value={editValues.serviceCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                size="lg"
                placeholder="Enter Service Charges"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="remarks"
                value={editValues.remarks}
                onChange={handleEditInputChange}
                placeholder="Enter Remarks"
                className={
                  fieldErrors.remarks[editingInvoice?.aA_Number]
                    ? "is-invalid"
                    : ""
                }
              />
              {fieldErrors.remarks[editingInvoice?.aA_Number] && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  {" "}
                  Remarks are required for mismatched data.
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label
                className="btn btn-secondary mb-0"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                }}
                onClick={() => modalFileInputRef.current.click()}
              >
                Upload File
              </Form.Label>

              <Form.Control
                type="file"
                id="fileUpload"
                name="uploadedFile"
                onChange={handleRemarkChange}
                style={{ display: "none" }}
                ref={modalFileInputRef}
              />

              {editValues.fileName && (
                <div className="mt-2 text-muted">
                  Selected File: {editValues.fileName}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveEdit}
            style={{
              backgroundColor: "#8000d7",
              border: "none",
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .table-container {
          overflow-x: auto;
          overflow-y: auto;
          max-height: 400px;
          width: 100%;
        }
        .network_table {
          min-width: 1200px;
        }
        .network_table th,
        .network_table td {
          padding: 2px;
          vertical-align: top;
        }
        .vendore_invoice_status {
          display: inline-block;
          white-space: nowrap;
        }
        .page-info {
          margin-top: 1rem;
          font-weight: 500;
        }
        .row-red {
          background-color: #ffe6e6;
          color: #d32f2f;
        }
        .row-yellow {
          background-color: #fff9c4;
        }
        .row-green {
          background-color: #e8f5e9;
        }
      `}</style>
    </div>
  );
};

export default QueryCasePage
